import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoTextBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 124,
	height: 12,
	viewBox: "0 0 124 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.70247 11.0377C1.62941 11.0377 0.0282324 9.96856 0 8.10454H2.14566C2.20212 8.89546 2.73047 9.41611 3.66214 9.41611C4.60591 9.41611 5.16249 8.92328 5.16249 8.21979C5.16249 6.09345 0.0121001 7.37323 0.0282328 3.80813C0.0282328 2.03154 1.48825 0.962402 3.54518 0.962402C5.59001 0.962402 6.99356 1.99179 7.11859 3.76838H4.91646C4.8721 3.12054 4.34375 2.61181 3.48468 2.59989C2.69821 2.57207 2.11339 2.95362 2.11339 3.75646C2.11339 5.7278 7.23152 4.63084 7.23152 8.09659C7.23555 9.64266 5.97719 11.0377 3.70247 11.0377Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3124 11.0377C10.4933 11.0377 8.19434 8.9511 8.19434 5.99409C8.19434 3.049 10.4973 0.962402 13.3124 0.962402C16.1599 0.962402 18.4185 3.049 18.4185 5.99409C18.4185 8.9511 16.1437 11.0377 13.3124 11.0377ZM13.3124 9.27701C15.1153 9.27701 16.3575 7.99325 16.3575 5.99409C16.3575 3.99095 15.1153 2.73899 13.3124 2.73899C11.4975 2.73899 10.2513 3.99493 10.2513 5.99409C10.2513 7.99325 11.4975 9.27701 13.3124 9.27701Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5928 1.10156H21.5932V7.19046C21.5932 8.54178 22.3353 9.24924 23.6098 9.24924C24.8964 9.24924 25.6426 8.54576 25.6426 7.19046V1.10156H27.6591V7.17456C27.6591 9.76592 25.7716 11.0378 23.5816 11.0378C21.3916 11.0378 19.5928 9.76989 19.5928 7.17456V1.10156Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.839 1.08569V10.9384H35.8386L31.3053 4.18976V10.9384H29.3008V1.08569H31.3012L35.8345 7.85025V1.08569H37.839Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.2764 6.03389C48.2764 9.0068 46.2034 10.9384 43.0131 10.9384H39.5244V1.10156H43.0131C46.2034 1.10156 48.2764 3.04508 48.2764 6.03389ZM42.9446 9.26116C45.0459 9.26116 46.2356 8.07677 46.2356 6.03389C46.2356 3.99101 45.0499 2.76289 42.9446 2.76289H41.5289V9.26116H42.9446Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.0685 0.974365C56.2867 0.974365 58.0855 2.14286 58.7591 4.15792H56.4561C55.9842 3.212 55.1252 2.74698 54.0523 2.74698C52.306 2.74698 51.0638 4.00292 51.0638 6.00208C51.0638 7.98932 52.306 9.25717 54.0523 9.25717C55.1252 9.25717 55.9842 8.79216 56.4561 7.83431H58.7591C58.0855 9.86527 56.2867 11.0179 54.0685 11.0179C51.1928 11.0179 49.0068 8.94717 49.0068 6.00208C49.0068 3.06097 51.1969 0.974365 54.0685 0.974365Z",
			fill: "#06D960"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.3135 9.06247H62.3368L61.6794 10.9384H59.5781L63.1677 1.08569H65.4988L69.0884 10.9384H66.971L66.3135 9.06247ZM64.3252 3.37102L62.8813 7.4846H65.7691L64.3252 3.37102Z",
			fill: "#06D960"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.1445 1.10156H72.4193L75.5934 8.4146L78.7675 1.10156H81.0261V10.9384H79.0256V4.53949L76.3516 10.9384H74.8351L72.145 4.53949V10.9384H70.1445V1.10156Z",
			fill: "#06D960"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.391 7.16264H84.7173V10.9384H82.7168V1.10156H86.391C88.7948 1.10156 89.9967 2.44096 89.9967 4.14601C89.9927 5.64042 88.9642 7.16264 86.391 7.16264ZM86.3023 5.56888C87.4316 5.56888 87.9317 5.0204 87.9317 4.14601C87.9317 3.24381 87.4316 2.70725 86.3023 2.70725H84.7173V5.56888H86.3023Z",
			fill: "#06D960"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.2442 9.06247H93.2675L92.6101 10.9384H90.5088L94.0983 1.08569H96.4295L100.019 10.9384H97.9016L97.2442 9.06247ZM95.2559 3.37102L93.812 7.4846H96.6998L95.2559 3.37102Z",
			fill: "#06D960"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.075 1.10156H103.076V10.9384H101.075V1.10156Z",
			fill: "#06D960"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.018 4.06253H111.715C111.259 3.23187 110.428 2.79467 109.367 2.79467C107.581 2.79467 106.334 4.05061 106.334 6.00605C106.334 8.00918 107.593 9.24922 109.452 9.24922C110.997 9.24922 111.985 8.37484 112.283 6.9798H108.851V5.47347H114.256V7.19044C113.856 9.19358 112.037 11.0218 109.379 11.0218C106.476 11.0218 104.273 8.95113 104.273 6.00605C104.273 3.06096 106.476 0.974365 109.363 0.974365C111.602 0.974365 113.376 2.08722 114.018 4.06253Z",
			fill: "#06D960"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124 1.08569V10.9384H122L117.466 4.18976V10.9384H115.466V1.08569H117.466L122 7.85025V1.08569H124Z",
			fill: "#06D960"
		})
	]
});
export default SvgLogoTextBlack;
